/*
 * PF OS — Bevakningar (mig 394).
 *
 * Hjärtat sparar ett smycke i besökarens enhet (localStorage). Första gången
 * frågar en dialog efter e-post: med den bevakar plattformen smycket och mejlar
 * om någon annan lägger det i varukorgen, om priset sänks eller om det säljs.
 * Utan e-post sparas det bara lokalt.
 *
 * Inloggad kund: listan följer kontot. Vid sidladdning slås enhetens lista
 * ihop med kontots ("sync") och kontots lista kommer tillbaka — samma på alla
 * enheter. Ingen e-postdialog: servern tar kundens e-post ur App Proxy-
 * signaturens logged_in_customer_id. Loggar man ut lämnar kontots lista enheten.
 *
 * Skickar också en anonym varukorgssignal (temats "variant:add") — det är den
 * som driver "någon annan har ditt sparade smycke i varukorgen".
 *
 * All kommunikation går till /apps/pf/watch (App Proxy → PF OS).
 */
// Intercom under menyn, varukorgen och hjärtlådan. Lådorna ligger på z-index
// 999 (Intercom sänkt till 998 i pf-watch-dialog), men menyn ärver sidhuvudets
// z-index 4 — Intercom döljs därför medan någon av dem är öppen.
(function () {
  var SEL = "header-menu-drawer, cart-drawer, x-drawer, x-drawer-popover";
  function sync() {
    document.documentElement.classList.toggle("pf-overlay-open", !!document.querySelector(
      "header-menu-drawer[open], cart-drawer[open], x-drawer[open], x-drawer-popover[open]",
    ));
  }
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].target.matches && list[i].target.matches(SEL)) return sync();
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["open"], subtree: true });
})();

(function () {
  "use strict";
  var KEY = "pf-watch-v1";
  var CID = "pf-cid";
  var dialog = document.querySelector("[data-pf-watch-dialog]");
  if (!dialog) return;
  var endpoint = dialog.getAttribute("data-endpoint");
  var loggedIn = dialog.hasAttribute("data-logged-in");
  var ctx = {
    locale: dialog.getAttribute("data-locale") === "sv" ? "sv" : "en",
    market: dialog.getAttribute("data-market") || undefined,
    country: dialog.getAttribute("data-country") || undefined,
    currency: dialog.getAttribute("data-currency") || undefined,
  };

  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || "null");
      return s && Array.isArray(s.items) ? s : { items: [] };
    } catch (e) {
      return { items: [] };
    }
  }
  function save(s) {
    try {
      localStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) {}
    paint();
    if (typeof renderSaved === "function") renderSaved();
  }
  function clientId() {
    try {
      var c = localStorage.getItem(CID);
      if (!c) {
        c = window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2) + Date.now();
        localStorage.setItem(CID, c);
      }
      return c;
    } catch (e) {
      return undefined;
    }
  }
  /** Svaret som objekt (null vid fel). */
  function postJson(body) {
    var payload = Object.assign({ client_id: clientId() }, ctx, body);
    return fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (d) { return r.ok && d && d.ok ? d : null; });
      })
      .catch(function () { return null; });
  }
  function post(body) {
    return postJson(body).then(function (d) { return !!d; });
  }

  function paint() {
    var s = load();
    var ids = {};
    s.items.forEach(function (i) { ids[String(i.id)] = true; });
    document.querySelectorAll("[data-pf-heart]").forEach(function (b) {
      b.setAttribute("aria-pressed", ids[b.getAttribute("data-product-id")] ? "true" : "false");
    });
    document.querySelectorAll("[data-pf-saved-dot]").forEach(function (d) { d.hidden = s.items.length === 0; });
    document.querySelectorAll("[data-pf-saved-count]").forEach(function (d) { d.textContent = s.items.length ? "(" + s.items.length + ")" : ""; });
  }

  function itemFrom(b) {
    return {
      id: b.getAttribute("data-product-id"),
      h: b.getAttribute("data-handle"),
      t: b.getAttribute("data-title"),
      i: b.getAttribute("data-image"),
      p: b.getAttribute("data-price"),
      at: Date.now(),
    };
  }

  /* Koppla e-post till ALLT som sparats på enheten (senaste först, max 20) —
     används av dialogen och av notisen i panelen. */
  function subscribeAll(email, extraId) {
    var s = load();
    var ids = s.items.slice(0, 20).map(function (i) { return String(i.id); });
    if (extraId && ids.indexOf(String(extraId)) < 0) ids.unshift(String(extraId));
    if (!ids.length) return Promise.resolve(false);
    // ETT anrop för allt: servern sparar alla och skickar EN bekräftelse som
    // listar dem. (Parallella anrop gav tidigare ett mejl per smycke.)
    return post({ action: "save", product_id: ids[0], product_ids: ids.slice(1), email: email })
      .then(function (ok) {
        if (!ok) return false;
        var s2 = load();
        s2.email = email;
        s2.asked = true;
        save(s2);
        return true;
      });
  }

  var pending = null;
  function openDialog(item) {
    pending = item;
    var form = dialog.querySelector("[data-pf-watch-form]");
    var success = dialog.querySelector("[data-pf-success]");
    var intro = dialog.querySelector("[data-pf-intro]");
    if (form) { form.hidden = false; form.style.display = ""; }
    if (intro) intro.style.display = "";
    if (success) success.hidden = true;
    if (typeof dialog.showModal === "function") dialog.showModal();
  }

  function toggle(b) {
    var s = load();
    var id = b.getAttribute("data-product-id");
    var idx = s.items.findIndex(function (i) { return String(i.id) === id; });
    if (idx >= 0) {
      s.items.splice(idx, 1);
      save(s);
      if (loggedIn) post({ action: "unsave", product_id: id });
      else if (s.email) post({ action: "unsave", product_id: id, email: s.email });
      return;
    }
    var item = itemFrom(b);
    s.items.unshift(item);
    s.items = s.items.slice(0, 100);
    save(s);
    if (loggedIn) {
      post({ action: "save", product_id: id });
    } else if (s.email) {
      post({ action: "save", product_id: id, email: s.email });
    } else {
      post({ action: "save", product_id: id });
      if (!s.asked) openDialog(item);
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var b = e.target.closest && e.target.closest("[data-pf-heart]");
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(b);
    },
    true,
  );

  // ── Dialogen ──────────────────────────────────────────────────────────
  (function () {
    var form = dialog.querySelector("[data-pf-watch-form]");
    var errorEl = dialog.querySelector("[data-pf-error]");
    var success = dialog.querySelector("[data-pf-success]");
    var intro = dialog.querySelector("[data-pf-intro]");
    dialog.querySelectorAll("[data-pf-close]").forEach(function (x) { x.addEventListener("click", function () { dialog.close(); }); });
    dialog.addEventListener("click", function (e) { if (e.target === dialog) dialog.close(); });
    var skip = dialog.querySelector("[data-pf-skip]");
    if (skip) skip.addEventListener("click", function () {
      var s = load();
      s.asked = true;
      save(s);
      dialog.close();
    });
    if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      if (errorEl) errorEl.hidden = true;
      var fd = new FormData(form);
      if (String(fd.get("website") || "").trim()) return;
      var email = String(fd.get("email") || "").trim().toLowerCase();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      subscribeAll(email, pending && pending.id)
        .then(function (ok) {
          if (ok) {
            form.hidden = true;
            form.style.display = "none";
            if (intro) intro.style.display = "none";
            if (success) success.hidden = false;
            setTimeout(function () { dialog.close(); }, 1800);
          } else if (errorEl) {
            errorEl.hidden = false;
          }
        })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  })();

  // ── Varukorgssignalen ─────────────────────────────────────────────────
  // Temats formulär skickar "variant:add"; produktsidans egen köpknapp
  // (product-info-rings) skickar "pf:cart-add". Tilläggen (gravyr, storleks-
  // och längdjustering) är egna rader med _childProduct — inte smycken.
  function onCartAdd(e) {
    var items = (e.detail && e.detail.items) || [];
    var sent = {};
    items.forEach(function (it) {
      if (!it || !it.product_id || sent[it.product_id]) return;
      if (it.properties && it.properties._childProduct) return;
      sent[it.product_id] = true;
      post({ action: "event", kind: "add_to_cart", product_id: String(it.product_id) });
    });
  }
  document.addEventListener("variant:add", onCartAdd);
  document.addEventListener("pf:cart-add", onCartAdd);

  // ── "Meddela mig när liknande" (slutsålda produktsidor) ───────────────
  document.querySelectorAll("[data-pf-notify-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      var fd = new FormData(form);
      if (String(fd.get("website") || "").trim()) return;
      var email = String(fd.get("email") || "").trim().toLowerCase();
      var btn = form.querySelector('button[type="submit"]');
      var err = form.querySelector("[data-pf-error]");
      if (btn) btn.disabled = true;
      if (err) err.hidden = true;
      post({ action: "notify_similar", product_id: form.getAttribute("data-product-id"), email: email })
        .then(function (ok) {
          if (ok) {
            var root = form.closest("[data-pf-notify]") || form;
            var done = root.querySelector("[data-pf-success]");
            form.hidden = true;
            form.style.display = "none";
            if (done) done.hidden = false;
            var s = load();
            if (!s.email) { s.email = email; save(s); }
          } else if (err) {
            err.hidden = false;
          }
        })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  });

  // ── Sparade smycken: panelen (glider upp) och sidan /apps/pf/sparade ──
  // Korten är temats EGNA produktkort, renderade av Shopify via den
  // alternativa mallen product.pf-card (/products/<handle>?view=pf-card).
  // Då blir padding, typografi, färgschema och pris i besökarens marknad
  // exakt som i kollektionerna — inga egna värden här. Cachas under besöket.
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var sv = ctx.locale === "sv";
  var cards = {};
  function fetchCard(h) {
    if (!cards[h]) {
      cards[h] = fetch(root + "products/" + encodeURIComponent(h) + "?view=pf-card")
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    }
    return cards[h];
  }
  function renderSaved() {
    var s = load();
    // Hjärtlådans lista skapas bara när det finns något att visa: temats
    // karusell (product-list) kastar fel vid varje storleksändring utan kort.
    var hosts = document.querySelectorAll("[data-pf-saved-host]");
    var grids = document.querySelectorAll("[data-pf-saved-list]:not(product-list)"); // /apps/pf/sparade
    if (!hosts.length && !grids.length) return;
    document.querySelectorAll("[data-pf-saved-empty]").forEach(function (e) { e.hidden = s.items.length > 0; });
    document.querySelectorAll("[data-pf-saved-notice]").forEach(function (n) {
      // Behåll tack-texten synlig direkt efter att e-posten angetts.
      if (n.getAttribute("data-done") === "1") return;
      n.hidden = !(s.items.length > 0 && !s.email && !loggedIn);
    });
    hosts.forEach(function (host) {
      if (!s.items.length) return host.replaceChildren();
      var list = document.createElement("product-list");
      list.className = host.getAttribute("data-list-class") || "";
      list.setAttribute("data-pf-saved-list", "");
      fillSaved(list, s.items); // korten/platshållarna först, sedan in i sidan
      host.replaceChildren(list);
    });
    grids.forEach(function (grid) {
      grid.innerHTML = "";
      fillSaved(grid, s.items);
    });
  }

  function fillSaved(list, items) {
    var closeTpl = document.getElementById("pf-close-icon");
    // Korten läggs DIREKT i listan (subgrid ger dem samma form som i
    // kollektionerna); en platshållare per smycke håller ordningen.
    items.forEach(function (it) {
      var slot = document.createElement("div");
      list.appendChild(slot);
      fetchCard(it.h).then(function (html) {
        if (!slot.parentNode) return;
        var holder = document.createElement("div");
        holder.innerHTML = html || "";
        var card = holder.querySelector("product-card, .product-card");
        if (!card) {
          slot.remove();
          if (list.tagName === "PRODUCT-LIST" && !list.children.length) list.remove();
          return;
        }
        var rm = document.createElement("button");
        rm.type = "button";
        rm.className = "pf-saved__remove";
        rm.setAttribute("aria-label", (sv ? "Ta bort " : "Remove ") + (it.t || ""));
        if (closeTpl) rm.appendChild(closeTpl.content.cloneNode(true));
        rm.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var s2 = load();
          s2.items = s2.items.filter(function (x) { return String(x.id) !== String(it.id); });
          save(s2);
          if (loggedIn) post({ action: "unsave", product_id: String(it.id) });
          else if (s2.email) post({ action: "unsave", product_id: String(it.id), email: s2.email });
        });
        card.appendChild(rm);
        slot.replaceWith(card);
      });
    });
  }


  document.querySelectorAll("[data-pf-notice-form]").forEach(function (form) {
    var box = form.closest("[data-pf-saved-notice]");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      var fd = new FormData(form);
      if (String(fd.get("website") || "").trim()) return;
      var err = box.querySelector("[data-pf-error]");
      var done = box.querySelector("[data-pf-success]");
      var btn = form.querySelector('button[type="submit"]');
      if (err) err.hidden = true;
      if (btn) btn.disabled = true;
      subscribeAll(String(fd.get("email") || "").trim().toLowerCase())
        .then(function (ok) {
          if (ok) {
            box.setAttribute("data-done", "1");
            form.hidden = true;
            form.style.display = "none";
            if (done) done.hidden = false;
          } else if (err) {
            err.hidden = false;
          }
        })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  });

  paint();
  renderSaved();
  document.addEventListener("shopify:section:load", paint);
  // Kollektionssidor laddar kort dynamiskt (filter, sidbyte) — måla om.
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; paint(); });
  }).observe(document.body, { childList: true, subtree: true });
  // ── Kontot ────────────────────────────────────────────────────────────
  (function () {
    var s = load();
    if (!loggedIn) {
      // Utloggad: listan som kom från kontot stannar inte på enheten.
      if (s.account) save({ items: [], asked: s.asked });
      return;
    }
    var started = Date.now();
    postJson({ action: "sync", product_ids: s.items.slice(0, 100).map(function (i) { return String(i.id); }) }).then(function (d) {
      if (!d || !Array.isArray(d.items)) return;
      var now = load();
      var ids = {};
      d.items.forEach(function (i) { ids[String(i.id)] = true; });
      // Det som sparats medan anropet pågick skickas separat — behåll det.
      var added = now.items.filter(function (i) { return i.at > started && !ids[String(i.id)]; });
      now.items = added.concat(d.items).slice(0, 100);
      now.account = true;
      now.asked = true;
      save(now);
    });
  })();
})();
